import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getField = (section, key) => section?.fields?.[key] || '';

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'background' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseSolutionDetailHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const backgroundImage = getMediaUrl(section, 'background');

  if (!fields.title || !backgroundImage) {
    return null;
  }

  return {
    category: fields.eyebrow || '',
    title: fields.title,
    description: fields.text || '',
    cta: {
      text: fields.ctaText || 'Contact Us',
      url: fields.ctaUrl || '/contact',
    },
    backgroundImage,
  };
};

export const parseSolutionDetailViewContent = (page) => {
  const section = getSection(page, 'view');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const items = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`item-${index}`];
    if (!value) {
      break;
    }
    items.push(value);
  }

  return {
    title: fields.title,
    description: fields.text || '',
    items,
    checkIcon: getMediaUrl(section, 'check-icon'),
  };
};

export const parseSolutionDetailWhatWeDeliverContent = (page) => {
  const section = getSection(page, 'what-we-deliver');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`deliverable-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`deliverable-${index}-text`] || '',
      icon: getMediaUrl(section, `deliverable-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'What We Deliver',
    items,
  };
};

export const parseSolutionDetailWhyChooseContent = (page) => {
  const section = getSection(page, 'why-choose');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const items = [];
  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
    });
  }

  return {
    title: fields.title,
    description: fields.text || '',
    items,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseSolutionDetailHowWeWorkContent = (page) => {
  const section = getSection(page, 'how-we-work');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const steps = [];
  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`step-${index}-title`];
    if (!title) {
      break;
    }

    steps.push({
      number: fields[`step-${index}-number`] || `${index}.`,
      title,
      description: fields[`step-${index}-description`] || '',
    });
  }

  if (steps.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    steps,
  };
};

export const parseSolutionDetailTimeIsValuableContent = (page) => {
  const section = getSection(page, 'time-is-valuable');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title || !fields.text) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/contact',
    },
  };
};

export const parseSolutionDetailContent = (page) => {
  if (!page) {
    return null;
  }

  return {
    hero: parseSolutionDetailHeroContent(page),
    view: parseSolutionDetailViewContent(page),
    whatWeDeliver: parseSolutionDetailWhatWeDeliverContent(page),
    whyChoose: parseSolutionDetailWhyChooseContent(page),
    howWeWork: parseSolutionDetailHowWeWorkContent(page),
    timeIsValuable: parseSolutionDetailTimeIsValuableContent(page),
  };
};
